import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	learnMoreOtherApps: {
		id: 'project-create-importer-upload-flow.upload-screen.import-from-other-tools.learn-more-other-apps',
		defaultMessage: 'Learn more about importing from other apps',
		description: 'Learn more link description',
	},
	comingSoon: {
		id: 'project-create-importer-upload-flow.upload-screen.import-from-other-tools.coming-soon',
		defaultMessage: 'Coming Soon',
		description: 'Coming Soon',
	},
	supportedAppsHeading: {
		id: 'project-create-importer-upload-flow.upload-screen.import-from-other-tools.supported-apps-heading',
		defaultMessage: 'Import from apps',
		description: 'Heading for import from apps section',
	},
	otherApps: {
		id: 'project-create-importer-upload-flow.upload-screen.import-from-other-tools.other-apps',
		defaultMessage: 'Are there any other apps you’d like to import data from? {link}',
		description:
			'Description text for button where users can tell us where they want to import data from',
	},
	tellUsWhere: {
		id: 'project-create-importer-upload-flow.upload-screen.import-from-other-tools.tell-us-where',
		defaultMessage: 'Let us know',
		description: 'Button text for tell us where cta',
	},
});
